export const DAMAGE_TYPES = [
  "bludgeoning",
  "piercing",
  "slashing",
  "acid",
  "cold",
  "electricity",
  "fire",
  "sonic",
  "force",
  "positive-energy",
  "negative-energy",
];

export const normalizeDamageType = (value = "") =>
  String(value).trim().toLowerCase().replace(/\s+/g, "-");
